<script setup>
import Heading from '@/components/shared/page/Heading.vue'
import AppVersion from '@/components/app/AppVersion.vue'

//Emits and props
defineProps({
  errorTitle: {
    type: String,
    default: 'Sorry, there was an error loading the app',
  },
  errorMessage: {
    type: String,
    default: 'Please try reloading the page or try again later.',
  },
  showSupportLink: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <div>
    <Heading
      size="l"
      :text="errorTitle"
    />
    <p>
      {{ errorMessage }}
      <span v-if="showSupportLink">
        <br>If the issue persists, please contact your administrator or training coordinator, or reach out to <a href="mailto:support@arist.co">Arist support</a> directly.
      </span>
    </p>
    <AppVersion />
  </div>
</template>
